// extracted by mini-css-extract-plugin
module.exports = {"block":"purchasedConnections_block__4TNUw","title":"purchasedConnections_title__k3HOm"};